import {
  ADD_INSTITUTION_FAILURE,
  ADD_INSTITUTION_REQUEST,
  ADD_INSTITUTION_SUCCESS,
  CLEAR_INSTITUTION_FETCH,
  GET_INSTITUTION_FAILURE,
  GET_INSTITUTION_REQUEST,
  GET_INSTITUTION_SUCCESS,
  GET_INSTITUTIONS_FAILURE,
  GET_INSTITUTIONS_REQUEST,
  GET_INSTITUTIONS_SUCCESS,
} from './institution.constant';
import { IAction, IInstitutionDetail } from '@shared-components/models';

export interface IInstitutionState {
  institutions: IInstitutionDetail[];
  institution: IInstitutionDetail;
  error: boolean | null;
  loading: boolean;
}
export const initialInstitutionState: IInstitutionState = {
  institutions: [],
  institution: {},
  error: null,
  loading: false,
};
export const INSTITUTION_FEATURE_KEY = 'institutions';

export const institutionReducer = (
  state = initialInstitutionState,
  action: IAction<any>
): any => {
  switch (action.type) {
    case GET_INSTITUTIONS_REQUEST:
      return { ...state, loading: true };
    case GET_INSTITUTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        institutions: [...action.payload],
      };
    case GET_INSTITUTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_INSTITUTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_INSTITUTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        institution: action.payload,
      };
    case CLEAR_INSTITUTION_FETCH:
      return {
        ...state,
        loading: false,
        error: null,
        institution: null,
      };
    case GET_INSTITUTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD_INSTITUTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_INSTITUTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        institutions: [...action.payload, ...state.institutions],
      };
    case ADD_INSTITUTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
